import * as PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import scopeLogger from '#/lib/scope-logger.js';

const console = scopeLogger('RMI:feature-flag');

Feature.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
};

export function Feature({
  name,
  children
}) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const enabled = isFeatureEnabled(name);
    console.log(`${name} - ${enabled}`);
    setEnabled(enabled);
  }, [name]);

  if (enabled) {
    return children;
  }

  return null;
}

/**
 *
 * @param {string} name
 * @return {boolean}
 */
export function isFeatureEnabled(name) {
  try {
    const saved = JSON.parse(localStorage.getItem('featuresFlags')) ?? {};
    return saved[name] === true;
  } catch(error){
    console.error(error);
    return false;
  }
}
